import React, { useRef, useState } from 'react';
import BenefitSection1Image1 from '../../assets/benefit_section1_image1.svg';
import BenefitSection1Image10 from '../../assets/benefit_section1_image10.svg';
import BenefitSection1Image11 from '../../assets/benefit_section1_image11.svg';
import BenefitSection1Image12 from '../../assets/benefit_section1_image12.svg';
import BenefitSection1Image13 from '../../assets/benefit_section1_image13.svg';
import BenefitSection1Image14 from '../../assets/benefit_section1_image14.svg';
import BenefitSection1Image15 from '../../assets/benefit_section1_image15.svg';
import BenefitSection1Image16 from '../../assets/benefit_section1_image16.svg';
import BenefitSection1Image17 from '../../assets/benefit_section1_image17.svg';
import BenefitSection1Image18 from '../../assets/benefit_section1_image18.png';
import BenefitSection1Image19 from '../../assets/benefit_section1_image19.png';
import BenefitSection1Image2 from '../../assets/benefit_section1_image2.svg';
import BenefitSection1Image20 from '../../assets/benefit_section1_image20.jpg';
import BenefitSection1Image3 from '../../assets/benefit_section1_image3.svg';
import BenefitSection1Image4 from '../../assets/benefit_section1_image4.svg';
import BenefitSection1Image5 from '../../assets/benefit_section1_image5.svg';
import BenefitSection1Image6 from '../../assets/benefit_section1_image6.svg';
import BenefitSection1Image9 from '../../assets/benefit_section1_image9.svg';
import { HorizontalEqualLayout, useResponsivePadding, VerticalLayout } from '../../common/common-layout';
import { Body1, Body3, H3, H7, Text3 } from '../../common/common-text';
import BTBox from '../../common/components/BTBox';
import { pxToRem } from '../../common/utils/ConvertUtils';
import '../../css/bbpage.css';
import { useDeviceType } from '../../hooks/useDeviceType';

const BenefitsSection1 = () => {
  const { horizontal: padding } = useResponsivePadding();
  const { isMobile } = useDeviceType();

  const scrollRef = useRef<HTMLDivElement>(null);
  const [isDragging, setIsDragging] = useState(false);
  const [startX, setStartX] = useState(0);
  const [scrollLeft, setScrollLeft] = useState(0);

  const onMouseDown = (e: React.MouseEvent) => {
    setIsDragging(true);
    setStartX(e.pageX - (scrollRef.current?.offsetLeft || 0));
    setScrollLeft(scrollRef.current?.scrollLeft || 0);
  };

  const onMouseLeave = () => {
    setIsDragging(false);
  };

  const onMouseUp = () => {
    setIsDragging(false);
  };

  const onMouseMove = (e: React.MouseEvent) => {
    if (!isDragging) return;
    e.preventDefault();
    const x = e.pageX - (scrollRef.current?.offsetLeft || 0);
    const walk = (x - startX) * 1; // 드래그 속도 조절
    if (scrollRef.current) {
      scrollRef.current.scrollLeft = scrollLeft - walk;
    }
  };


  return (
    <VerticalLayout paddingLeft={padding} paddingRight={padding} style={{ background: 'white' }}>
      <BTBox height={isMobile ? 40 : `${pxToRem(100)}`} />
      <H3>Employee Benefits</H3>
      <BTBox height={isMobile ? 8 : `${pxToRem(25)}`} />
      <Body1 style={{ flex: 1, opacity: '0.5' }}>
        안정된 직장생활을 보장하여 구성원의 사기진작을 도모하고
        신바람 나는 일터를 만들기 위해 지속적으로 복리후생 제도를 개선하고 있습니다.
      </Body1>

      {!isMobile ? (
        <>
          <BTBox height={`${pxToRem(117)}`} />
          <div style={{ width: '100%' }}>
            <img src={BenefitSection1Image9} style={{ width: '100%' }} />
          </div>
        </>
      ) : (
        <>
          <BTBox height={54} />
          <img
            src={BenefitSection1Image9}
            style={{ width: '100%', height: 'auto' }}
          />
        </>
      )}
      <BTBox height={isMobile ? 46 : `${pxToRem(120)}`} />

      <HorizontalEqualLayout
        gap={isMobile ? 20 : 68}
        style={{
          alignItems: 'start',
          flexDirection: isMobile ? 'column' : 'row',
        }}
      >
        {[1, 2, 3].map((_, index) => (
          <VerticalLayout
            key={index}
            height={isMobile ? 'auto' : pxToRem(400)}
            style={{ width: isMobile ? '100%' : undefined }}
          >
            <img
              src={
                index === 0
                  ? BenefitSection1Image1
                  : index === 1
                    ? BenefitSection1Image2
                    : BenefitSection1Image3
              }
            />
            <BTBox height={pxToRem(20)} />
            <Body3>
              {index === 0
                ? '4대 사회보험'
                : index === 1
                  ? '단체상해보험'
                  : '보상제도'}
            </Body3>
            <BTBox height={pxToRem(20)} />
            <Text3 style={{ height: isMobile ? 'auto' : pxToRem(146), opacity: '0.5' }}>
              {index === 0 &&
                '국민연금, 건강보험, 고용보험, 산재보험 등 기본적인 사회안전망은 물론, 여러분의 삶을 오래도록 지켜주는 제도들을 모두 갖추고 있습니다. 회사 생활의 시작부터 퇴직 이후까지, 안심하고 일하실 수 있어요.'}
              {index === 1 &&
                '일상 속 예기치 못한 사고에도 걱정 없이 회복에만 집중할 수 있도록, 임직원 모두에게 단체상해보험을 제공합니다. 최대 1억 5천만 원까지 보장되는 혜택으로 여러분의 건강을 함께 지켜드립니다.'}
              {index === 2 &&
                '오랫동안 함께한 구성원에게는 감사의 마음을 담아 장기근속 포상을 드리고, 우수한 성과를 낸 분들에겐 표창과 격려가 이어집니다. 퇴직 시에는 정당한 보상을 통해 아름답게 마무리하실 수 있도록 퇴직금(또는 퇴직연금) 제도도 운영 중입니다.'}
            </Text3>
            <BTBox height={isMobile ? 24 : pxToRem(116)} />
            <VerticalLayout height={1} backgroundColor="black" style={{ opacity: '0.2' }} />
          </VerticalLayout>
        ))}
      </HorizontalEqualLayout>

      <BTBox height={isMobile ? 20 : pxToRem(80)} />

      <HorizontalEqualLayout
       gap={isMobile ? 20 : 68}
        style={{
          alignItems: 'start',
          flexDirection: isMobile ? 'column' : 'row',
        }}
      >
        <VerticalLayout
          height={isMobile ? 'auto' : pxToRem(400)}
          style={{ width: isMobile ? '100%' : undefined }}
        >
          <img src={BenefitSection1Image4} />
          <BTBox height={pxToRem(20)} />
          <Body3>경조금 및 경조휴가</Body3>
          <BTBox height={pxToRem(20)} />
          <Text3 style={{ height: isMobile ? 'auto' : pxToRem(146), opacity: '0.5' }}>
            기쁜 날에도, 어려운 날에도 BBTECH는 늘 곁에 있습니다. 결혼, 출산, 부모님의 일 등 구성원 개개인의 삶의 순간을 존중하며, 필요한 경우에는 경조금과 경조휴가를 통해 따뜻한 응원을 전하고 있습니다.
          </Text3>
          <BTBox height={isMobile ? 24 : pxToRem(116)} />
          <VerticalLayout height={1} backgroundColor="black" style={{ opacity: '0.2' }} />
        </VerticalLayout>

        <VerticalLayout
          height={isMobile ? 'auto' : pxToRem(400)}
          style={{ width: isMobile ? '100%' : undefined }}
        >
          <img src={BenefitSection1Image5} />
          <BTBox height={pxToRem(20)} />
          <Body3>정기 건강검진</Body3>
          <BTBox height={pxToRem(20)} />
          <Text3 style={{ height: isMobile ? 'auto' : pxToRem(146), opacity: '0.5' }}>
            매년 진행되는 건강검진을 통해 구성원 여러분의 신체 건강을 꼼꼼히 살피고 있습니다. 바쁜 일상 속에서도 본인의 건강을 챙길 수 있도록 회사가 먼저 챙깁니다.
          </Text3>
          <BTBox height={isMobile ? 24 : pxToRem(116)} />
          <VerticalLayout height={1} backgroundColor="black" style={{ opacity: '0.2' }} />
        </VerticalLayout>

        <VerticalLayout
          height={isMobile ? 'auto' : pxToRem(400)}
          style={{ width: isMobile ? '100%' : undefined }}
        >
          <img src={BenefitSection1Image6} />
          <BTBox height={pxToRem(20)} />
          <Body3>사내 동호회 활동 지원</Body3>
          <BTBox height={pxToRem(20)} />
          <Text3 style={{ height: isMobile ? 'auto' : pxToRem(146), opacity: '0.5' }}>
            일도 중요하지만, 함께 웃고 즐기는 시간도 소중하니까요. 다양한 분야의 동호회 활동을 장려하고, 구성원들이 스스로 모임을 만들고 운영할 수 있도록 적극적으로 지원합니다. 회사에서 친구도 만들고, 취미도 함께 즐겨보세요!
          </Text3>
          <BTBox height={isMobile ? 24 : pxToRem(116)} />
          <VerticalLayout height={1} backgroundColor="black" style={{ opacity: '0.2' }} />
        </VerticalLayout>
      </HorizontalEqualLayout>

      <BTBox height={isMobile ? 20 : pxToRem(80)} />

      <HorizontalEqualLayout
       gap={isMobile ? 20 : 68}
        style={{
          alignItems: 'start',
          flexDirection: isMobile ? 'column' : 'row',
        }}
      >
        <VerticalLayout
          height={isMobile ? 'auto' : pxToRem(400)}
          style={{ width: isMobile ? '100%' : undefined }}
        >
          <img src={BenefitSection1Image10} />
          <BTBox height={pxToRem(20)} />
          <Body3>자격취득 지원</Body3>
          <BTBox height={pxToRem(20)} />
          <Text3 style={{ height: isMobile ? 'auto' : pxToRem(146), opacity: '0.5' }}>
            당신의 성장은 곧 회사의 성장입니다. 업무와 관련된 자격증을 준비하신다면, 응시료와 교육비 등 다양한 지원을 아끼지 않습니다. 배움의 걸음을 응원합니다.
          </Text3>
          <BTBox height={isMobile ? 24 : pxToRem(116)} />
          <VerticalLayout height={1} backgroundColor="black" style={{ opacity: '0.2' }} />
        </VerticalLayout>

        <VerticalLayout
          height={isMobile ? 'auto' : pxToRem(400)}
          style={{ width: isMobile ? '100%' : undefined }}
        >
          <img src={BenefitSection1Image11} />
          <BTBox height={pxToRem(20)} />
          <Body3>자유로운 연차 사용</Body3>
          <BTBox height={pxToRem(20)} />
          <Text3 style={{ height: isMobile ? 'auto' : pxToRem(146), opacity: '0.5' }}>
            눈치 보지 않고, 원하는 시기에 쉴 수 있어야 진짜 휴가죠. 연중 언제든 자유롭게 사용할 수 있는 연중휴가제를통해, 리프레시가 필요할 땐 망설이지 마세요. 충분히 쉬고 돌아오면, 더 좋은 하루가 기다리고 있을 거예요.
          </Text3>
          <BTBox height={isMobile ? 24 : pxToRem(116)} />
          <VerticalLayout height={1} backgroundColor="black" style={{ opacity: '0.2' }} />
        </VerticalLayout>

        <VerticalLayout
          height={isMobile ? 'auto' : pxToRem(400)}
          style={{ width: isMobile ? '100%' : undefined }}
        >
          <img src={BenefitSection1Image12} />
          <BTBox height={pxToRem(20)} />
          <Body3>명절선물</Body3>
          <BTBox height={pxToRem(20)} />
          <Text3 style={{ height: isMobile ? 'auto' : pxToRem(146), opacity: '0.5' }}>
            고마운 사람들과 함께 나누는 마음, 그게 명절의 따뜻함이죠. 설날, 추석 등 주요 명절에 감사의 마음을 담아 정성스러운 선물을 전달드리고 있습니다.
          </Text3>
          <BTBox height={isMobile ? 24 : pxToRem(116)} />
          <VerticalLayout height={1} backgroundColor="black" style={{ opacity: '0.2' }} />
        </VerticalLayout>
      </HorizontalEqualLayout>

      <BTBox height={isMobile ? 20 : pxToRem(80)} />

      <HorizontalEqualLayout
       gap={isMobile ? 20 : 68}
        style={{
          alignItems: 'start',
          flexDirection: isMobile ? 'column' : 'row',
        }}
      >
        <VerticalLayout
          height={isMobile ? 'auto' : pxToRem(400)}
          style={{ width: isMobile ? '100%' : undefined }}
        >
          <img src={BenefitSection1Image13} />
          <BTBox height={pxToRem(20)} />
          <Body3>식사지원</Body3>
          <BTBox height={pxToRem(20)} />
          <Text3 style={{ height: isMobile ? 'auto' : pxToRem(146), opacity: '0.5' }}>
            든든하게 먹어야 하루도 힘이 나죠. 임직원 모두가 건강한 하루를 시작하고, 집중해서 업무에 몰입하실 수 있도록 조식과 중식을 제공하고 있습니다. 부득이하게 늦게까지 근무하시는 경우엔 따뜻한 석식도 제공해 드려요. 여유 있는 하루, 균형 있는 일상을 함께 만들어갑니다.
          </Text3>
          <BTBox height={isMobile ? 24 : pxToRem(116)} />
          <VerticalLayout height={1} backgroundColor="black" style={{ opacity: '0.2' }} />
        </VerticalLayout>

        <VerticalLayout
          height={isMobile ? 'auto' : pxToRem(400)}
          style={{ width: isMobile ? '100%' : undefined }}
        >
          <img src={BenefitSection1Image14} />
          <BTBox height={pxToRem(20)} />
          <Body3>현장 숙소 운영</Body3>
          <BTBox height={pxToRem(20)} />
          <Text3 style={{ height: isMobile ? 'auto' : pxToRem(146), opacity: '0.5' }}>
            현장 근무도 집처럼 편안할 수 있도록. 지방 프로젝트 현장근무 시 숙소를 제공해 불편함을 줄이고 업무에 집중할 수 있도록 배려하고 있습니다. 편히 쉬며 내일의 에너지를 충전하세요.
          </Text3>
          <BTBox height={isMobile ? 24 : pxToRem(116)} />
          <VerticalLayout height={1} backgroundColor="black" style={{ opacity: '0.2' }} />
        </VerticalLayout>

        <VerticalLayout
          height={isMobile ? 'auto' : pxToRem(400)}
          style={{ width: isMobile ? '100%' : undefined }}
        >
          <img src={BenefitSection1Image15} />
          <BTBox height={pxToRem(20)} />
          <Body3>장례물품 지원</Body3>
          <BTBox height={pxToRem(20)} />
          <Text3 style={{ height: isMobile ? 'auto' : pxToRem(146), opacity: '0.5' }}>
            예기치 못한 가족의 이별 앞에서, 혼자가 아닙니다. 임직원의 직계가족이 별세하였을 경우, 필요한 장례물품을 지원하여 마음을 다해 함께합니다. 따뜻한 위로가 되길 바랍니다.
          </Text3>
          <BTBox height={isMobile ? 24 : pxToRem(116)} />
          <VerticalLayout height={1} backgroundColor="black" style={{ opacity: '0.2' }} />
        </VerticalLayout>
      </HorizontalEqualLayout>

      <BTBox height={isMobile ? 20 : pxToRem(80)} />

      <HorizontalEqualLayout
       gap={isMobile ? 20 : 68}
        style={{
          alignItems: 'start',
          flexDirection: isMobile ? 'column' : 'row',
        }}
      >
        <VerticalLayout
          height={isMobile ? 'auto' : pxToRem(400)}
          style={{ width: isMobile ? '100%' : undefined }}
        >
          <img src={BenefitSection1Image16} />
          <BTBox height={pxToRem(20)} />
          <Body3>가족친화제도</Body3>
          <BTBox height={pxToRem(20)} />
          <Text3 style={{ height: isMobile ? 'auto' : pxToRem(146), opacity: '0.5' }}>
            가족과 함께하는 시간이 존중받는 회사. 임신기 단축근무, 출산휴가, 남녀 육아휴직 등 법정 기준에 따라 제도를 운영하며, 누구나 가족과의 시간을 소중히 지킬 수 있도록 지원합니다.
          </Text3>
          <BTBox height={isMobile ? 24 : pxToRem(116)} />
          <VerticalLayout height={1} backgroundColor="black" style={{ opacity: '0.2' }} />
        </VerticalLayout>

        <VerticalLayout
          height={isMobile ? 'auto' : pxToRem(400)}
          style={{ width: isMobile ? '100%' : undefined }}
        >
          <img src={BenefitSection1Image17} />
          <BTBox height={pxToRem(20)} />
          <Body3>사내카페</Body3>
          <BTBox height={pxToRem(20)} />
          <Text3 style={{ height: isMobile ? 'auto' : pxToRem(146), opacity: '0.5' }}>
            바쁜 하루 속, 잠시 숨을 고를 수 있는 여유가 필요하죠. 누구나 자유롭게 이용 가능한 사내카페가 있어 편안하게 커피 한 잔 하며 동료들과 웃음도 나눌 수 있어요.
          </Text3>
          <BTBox height={isMobile ? 50 : pxToRem(116)} />
          <VerticalLayout height={1} backgroundColor="black" style={{ opacity: '0.2' }} />
        </VerticalLayout>

        <VerticalLayout
          height={isMobile ? '40px' : pxToRem(400)}
          style={{ width: isMobile ? '100%' : undefined }}
        >
        </VerticalLayout>
      </HorizontalEqualLayout>
      <BTBox height={pxToRem(100)} />
      <H7>
        Space
      </H7>
      <BTBox height={pxToRem(20)} />

      <div
        ref={scrollRef}
        style={{
          width: "100%",
          overflowX: "auto",
          whiteSpace: "nowrap",
          scrollbarWidth: "auto", // 스크롤바 표시
          msOverflowStyle: "auto",
          cursor: isDragging ? "grabbing" : "grab",
        }}
        onMouseDown={onMouseDown}
        onMouseLeave={onMouseLeave}
        onMouseUp={onMouseUp}
        onMouseMove={onMouseMove}
      >
        <div
          style={{
            display: 'inline-flex', // 한 줄로 쭉 나열
            height: `${pxToRem(500)}`,
          }}
        >
          <img
            src={BenefitSection1Image18}
            draggable={false}
            style={{ height: '100%', flexShrink: 0 }}
          />
          <BTBox width={16} />
          <img
            src={BenefitSection1Image19}
            draggable={false}
            style={{ height: '100%', flexShrink: 0 }}
          />
          <BTBox width={16} />
          <img
            src={BenefitSection1Image20}
            draggable={false}
            style={{ height: '100%', flexShrink: 0 }}
          />
        </div>
      </div>



      <BTBox height={pxToRem(282)} />
    </VerticalLayout>
  );
};

export default BenefitsSection1;
